var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract" },
    [
      _vm.$route.query.isApp == 1 && _vm.$route.query.isBanner == 0
        ? _c("div", [
            !_vm.isLoading && _vm.linkType != 3
              ? _c("div", { staticClass: "contract-header" }, [
                  _c("div", [
                    _c("i", {
                      staticClass: "iconfont icon-xiangyou",
                      class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$route.query.isBanner == 0 && !_vm.isLoading
              ? _c("div", { staticClass: "contract-header" }, [
                  _c("div", [
                    _c("i", {
                      staticClass: "iconfont icon-xiangyou",
                      class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scroll-box", class: _vm.isHeader },
        [
          this.$route.query.isApp != 1
            ? _c("InCompleteSiteHead", { staticClass: "InCompleteSiteHead" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "model1" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.resultObj.title) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "model2" }, [
              _c("div", { staticClass: "model2_text" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("9100080")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("tradeCompetition", {
                    attrs: { "end-time": _vm.resultObj.endTime, type: "2" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "model3" }, [
              _c("div", { staticClass: "model3_box" }, [
                _c("img", { attrs: { src: _vm.resultObj.h5Img } })
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.changeApplication,
                on: { click: _vm.toApplication }
              },
              [_vm._v(_vm._s(_vm.textVar))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "model4" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("9100081")))]),
              _vm._v(" "),
              _c("span", { on: { click: _vm.goRuler } }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("9100082")) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "model5", on: { click: _vm.goShareUrl } },
              [
                _c("img", {
                  attrs: { src: require("../assets/images/fenxiang.svg") }
                }),
                _vm._v(" "),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("300342")) +
                    "\n            "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mainBody" }, [
            _c(
              "div",
              { staticClass: "mainBody-content" },
              _vm._l(_vm.subResultArray, function(item, index) {
                return _c("div", { key: index }, [
                  _c(
                    "div",
                    {
                      staticClass: "content_title",
                      class: { "no-margin-top": index === 0 }
                    },
                    [
                      _c("div", { staticClass: "left_line" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "center_text" }, [
                        _vm._v(_vm._s(_vm.$t("9100084"))),
                        _c("span", [_vm._v(_vm._s(index + 1))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right_line" })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content_content" }, [
                    _c("div", { staticClass: "content_content-left" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _vm._v(" "),
                      _c("p", { domProps: { innerHTML: _vm._s(item.rule) } }),
                      _vm._v(" "),
                      item.h5Img
                        ? _c("div", { staticClass: "actImg" }, [
                            _c("img", { attrs: { src: item.h5Img } })
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "content_content-right",
                        on: {
                          click: function($event) {
                            return _vm.toUrl(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "toTrade" }, [
                          _vm._v(_vm._s(_vm.changeText(item)))
                        ])
                      ]
                    )
                  ])
                ])
              }),
              0
            ),
            _vm._v(" "),
            !_vm.$route.query.isApp
              ? _c("div", { staticClass: "returnPro" }, [
                  _c(
                    "div",
                    {
                      staticClass: "returnPro-test",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("300358")) +
                          "\n                    "
                      ),
                      _c("img", {
                        attrs: {
                          src: require("../assets/images/returnPro.svg")
                        }
                      })
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mainBody-ruler1" }),
            _vm._v(" "),
            _c("div", { staticClass: "mainBody-ruler" }, [
              _c("div", { staticClass: "ruler_title" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("300140")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("p", { domProps: { innerHTML: _vm._s(_vm.resultObj.rule) } })
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.buySuccessShare
        ? _c("div", { staticClass: "purchase_toast" }, [
            _c("div", { staticClass: "shareBox" }, [
              _c("img", {
                attrs: { src: require("../assets/images/xuanZhong111.png") }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "boldShare" }, [
                _vm._v(_vm._s(_vm.$t("300027")))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tip-popup",
          style: { width: "15.6rem", padding: "1.2rem" },
          attrs: { round: "" },
          model: {
            value: _vm.sucPoint,
            callback: function($$v) {
              _vm.sucPoint = $$v
            },
            expression: "sucPoint"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "svg",
                {
                  staticClass: "icon boxIcon",
                  attrs: { slot: "image", "aria-hidden": "true" },
                  slot: "image"
                },
                [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("9100028")))]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  staticClass: "confirmBtn",
                  on: {
                    click: function($event) {
                      _vm.sucPoint = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("300141")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "tip-popup",
          style: { width: "15.6rem", padding: "1.2rem" },
          attrs: { round: "" },
          model: {
            value: _vm.noStartTip,
            callback: function($$v) {
              _vm.noStartTip = $$v
            },
            expression: "noStartTip"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "svg",
                {
                  staticClass: "icon boxIcon",
                  attrs: { slot: "image", "aria-hidden": "true" },
                  slot: "image"
                },
                [_c("use", { attrs: { "xlink:href": "#icon-tishi-1" } })]
              ),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.signUpMsg))]),
              _vm._v(" "),
              _c(
                "van-button",
                {
                  staticClass: "confirmBtn",
                  on: {
                    click: function($event) {
                      _vm.noStartTip = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("300141")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-393aeb5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-393aeb5c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/tradeCompetition.vue
// module id = QKXt
// module chunks = 0